import {
  programmeQuery,
  programmeRevisionsQuery,
} from "@common/api/maintenance-programme"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DetailPane } from "@/components/layout/detail-panel"
import useCustomToast from "@/hooks/use-custom-toast"
import { revisionLabel } from "@/routes/_layout/maintenance-programmes/-lib/revision-label"
import { PaneHeading } from "../-components/pane-heading"
import { RevisionForm } from "../-components/revision-form/revision-form"
import { copyableRevisions } from "../-lib/revision"
import { REVISIONS } from "../-lib/search"

export const Route = createFileRoute(
  "/_layout/maintenance-programmes_/$programmeId/revisions/new",
)({
  component: NewRevisionPane,
})

function NewRevisionPane(): React.ReactElement {
  const { programmeId } = Route.useParams()
  const { data: programme } = useSuspenseQuery(
    programmeQuery({ programme_id: programmeId }),
  )
  const { data: revisions } = useSuspenseQuery(
    programmeRevisionsQuery({ programme_id: programmeId, ...REVISIONS }),
  )
  const copyable = copyableRevisions(revisions.data)
  const base =
    copyable.find(({ id }) => id === programme.current_revision?.id) ??
    copyable[0]
  const navigate = useNavigate({ from: Route.fullPath })
  const showToast = useCustomToast()
  const close = () =>
    navigate({
      to: "/maintenance-programmes/$programmeId",
      params: { programmeId },
      search: true,
    })

  return (
    <DetailPane
      title="New revision"
      heading={<PaneHeading title="New revision" subtitle={programme.title} />}
      onClose={close}
    >
      <RevisionForm
        programmeId={programmeId}
        base={base?.id ?? null}
        onCreate={(created) => {
          showToast(
            `Created ${revisionLabel(created.number)}`,
            "Draft revision",
            "success",
          )
          navigate({
            to: "/maintenance-programmes/$programmeId",
            params: { programmeId },
            search: (previous) => ({
              ...previous,
              tab: undefined,
              revision: created.id,
            }),
          })
        }}
        onCancel={close}
      />
    </DetailPane>
  )
}
